import * as React from 'react';
import { Component } from 'react';


interface IProps {
    Checked: boolean,
    OnClick: () => void,
    Label: string,
    Color?: string
}

export class CheckBoxComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnClick = this.OnClick.bind(this);
    }

    public render() {
        return (
            <div className="checkbox-container" onClick={this.OnClick}>
                <input
                    type="checkbox"
                    checked={this.props.Checked}
                    onChange={this.OnInputChange} />
                {
                    this.props.Color ?
                        (
                            <span className="checkmark" style={{
                                backgroundColor: this.props.Checked ? this.props.Color : 'none',
                                borderColor: this.props.Color
                            }} />
                        ) :
                        (<span className="checkmark" />)
                }
                <label>{this.props.Label}</label>
            </div>
        );
    }

    private OnClick(evt) {
        this.props.OnClick();
    }

    private OnInputChange(evt) {
        //null
    }
}


// WEBPACK FOOTER //
// ./src/controls/CheckBox.tsx